module.exports = __webpack_public_path__ + "assets/just-eat-mobile-logo-6faebd.svg";